module.exports = __webpack_public_path__ + "img/baosteel.8d654475.png";